// 📁 src/components/auth/ResetPasswordPage.jsx

import React, { useState } from 'react';

export default function ResetPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleResetRequest = async (e) => {
    e.preventDefault();

    const registry = JSON.parse(localStorage.getItem('accountRegistry') || '{}');

    if (!email || !registry[email]) {
      setMessage('❌ This email is not associated with any account.');
      return;
    }

    // ✅ Hydrate tenantId for audit tagging
    const tenantId = registry[email].tenantId;
    if (tenantId) {
      localStorage.setItem('tenantId', tenantId);
      console.log('🏷️ Hydrated tenantId:', tenantId);
    }

    try {
      const response = await fetch('http://localhost:3001/api/email/send-password-reset-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const result = await response.json();
      if (result.success) {
        setMessage('✅ Password reset email has been sent to your email.');
      } else {
        setMessage('❌ Failed to send reset email. Please try again.');
      }
    } catch (err) {
      console.error('❌ Error during reset dispatch:', err);
      setMessage('❌ Server error. Please try again later.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="p-8 bg-white rounded shadow w-full max-w-md">
        <h2 className="text-2xl font-bold text-center mb-6">Request Password Reset</h2>
        <form onSubmit={handleResetRequest} className="space-y-4">
          <input
            type="email"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full p-3 border rounded"
          />
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700"
          >
            Send Reset Link
          </button>
          {message && <p className="text-center text-sm text-indigo-600">{message}</p>}
        </form>
      </div>
    </div>
  );
}
